<div class="row d-flex justify-content-center">
  <button *ngIf="showPreviousPage" (click)="onPrev()" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0"
    class="btn-c btn-transparent">{{ lextranslate.i18n["0bfcb551-00b4-4581-9436-04acd362e0ca"] }}
  </button>

  <button disabled *ngIf="!showPreviousPage" (click)="onPrev()" aria-controls="DataTables_Table_0" data-dt-idx="0"
    tabindex="0" class="btn-disabled-c btn-transparent">{{ lextranslate.i18n["0bfcb551-00b4-4581-9436-04acd362e0ca"] }}
  </button>

  <ngb-pagination (pageChange)="onclick($event)" class="d-flex justify-content-center"
    [collectionSize]="nTamanhoPagination" [(pageSize)]="nItensPerPage" [maxSize]="3" [(page)]="nDefault" [rotate]="true"
    [boundaryLinks]="false" [directionLinks]="false">
  </ngb-pagination>

  <button *ngIf="showNextPage" (click)="onNext()" class="btn-c btn-transparent">{{ lextranslate.i18n["a6e4048f-16d3-4958-928c-f8713badda47"] }}</button>
  <button disabled *ngIf="!showNextPage" (click)="onNext()" class="btn-disabled-c btn-transparent">{{ lextranslate.i18n["a6e4048f-16d3-4958-928c-f8713badda47"] }}</button>
</div>
